import { Info } from 'lucide-react';
import { Card, CardContent } from '@/components/shadcn/card';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/shadcn/tooltip';

interface KpiCardProps {
  label: string;
  value: string | number;
  tooltip: string;
}

export const KpiCard = ({ label, value, tooltip }: KpiCardProps) => (
  <Card className='rounded-md py-0'>
    <CardContent className='p-5'>
      <div className='flex items-start justify-between gap-4'>
        <div className='min-w-0 space-y-2'>
          <p className='text-sm text-slate-600'>{label}</p>
          <p className='text-2xl font-semibold tracking-tight text-slate-950'>{value}</p>
        </div>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                type='button'
                className='cursor-help rounded-sm text-slate-500 outline-none focus-visible:ring-2 focus-visible:ring-ring'
              >
                <Info className='size-4' aria-hidden='true' />
                <span className='sr-only'>{label} purpose</span>
              </button>
            </TooltipTrigger>
            <TooltipContent className='max-w-xs'>{tooltip}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </CardContent>
  </Card>
);
